import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const humanNamePattern = /^[A-Za-z0-9'\-\. ]+$/; // NOSONAR
export const humanNameValid = (control: FormControl) =>
    !control.value || (control.value.trim().length >= 2 && humanNamePattern.test(control.value))
        ? null
        : { humanName: messages.validation.humanName };

export const alulaNamePattern = /^[A-Za-z]+$/; // NOSONAR
export const alulaNameValid = (control: FormControl) =>
    !control.value || (control.value.trim().length >= 2 && alulaNamePattern.test(control.value))
        ? null
        : { alulaName: messages.validation.alulaName };
